import React from 'react'

interface ArrowProps {
  classNames: string
}

export const Arrow = (props: ArrowProps) => (
  <svg
    className={props.classNames} //"ExportMenu-arrow"
    width='5'
    height='8'
    viewBox='0 0 5 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      className='ExportMenu-arrow-path'
      d='M0.25 1.3225L2.95412 4L0.25 6.6775L1.08249 7.5L4.625 4L1.08249 0.5L0.25 1.3225Z'
      fill='white'
    />
  </svg>
)
